/** @jsx jsx */

// import React from 'react';
import { css, jsx } from '@emotion/core';

type ColumnType = {
  id: string;
  className: string;
  flexDirection: string;
  justifyContent: string;
  flex: number;
  margin: string;
  children: React.ReactNode;
  rest: any;
};

export const Column = ({
  id,
  className,
  flexDirection = 'column',
  justifyContent = 'center',
  flex = 1,
  margin = '8px',
  children,
  ...rest
}: Partial<ColumnType>) => {
  //

  return (
    <div
      style={
        {
          display: 'flex',
          flexDirection,
          justifyContent,
          flex,
          margin,
          ...rest,
        } as any
      }
    >
      {children}
    </div>
  );
};

type RowType = {
  id: string;
  className: string;
  flexDirection: string;
  justifyContent: string;
  flex: number;
  margin: string;
  children: React.ReactNode;
  rest: any;
};

export const Row = ({
  id,
  className,
  flexDirection,
  justifyContent,
  flex = 0,
  margin = '8px',
  children,
  ...rest
}: Partial<RowType>) => {
  //
  return (
    <div
      css={{
        display: 'flex',
        flexDirection,
        justifyContent,
        flex,
        margin,

        '@media (max-width: 767px)': {
          flexDirection: 'column',
        },

        ...(rest as any),
      }}
    >
      {children}
    </div>
  );
};
